import { render } from "./BlockVersion.vue?vue&type=template&id=0b8edca6&ts=true"
import script from "./BlockVersion.vue?vue&type=script&lang=ts"
export * from "./BlockVersion.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__